(() => {
  const sectionSelector = ".xts-frequently-bought";
  const headerMountSelector = "[data-xts-frequently-bought-header-mount]";
  const mountSelector = "[data-xts-frequently-bought-mount]";
  const widgetSelector = ".cbb-frequently-bought-container";
  const widgetHeaderSelectors = [
    ".cbb-frequently-bought-title",
    ".cbb-frequently-bought-discount-message-container",
  ];
  const movedAttribute = "data-xts-frequently-bought-moved";
  const movedHeaderAttribute = "data-xts-frequently-bought-header-moved";

  const moveWidgetHeader = (section, widget) => {
    const headerMount = section.querySelector(headerMountSelector);

    if (!headerMount || !widget) {
      return;
    }

    widgetHeaderSelectors.forEach((selector) => {
      const element = widget.querySelector(selector);

      if (!element) {
        return;
      }

      headerMount
        .querySelectorAll(`${selector}[${movedHeaderAttribute}]`)
        .forEach((currentElement) => currentElement.remove());

      element.setAttribute(movedHeaderAttribute, "true");
      headerMount.appendChild(element);
    });
  };

  const moveWidget = () => {
    const section = document.querySelector(sectionSelector);
    const mount = section?.querySelector(mountSelector);

    if (!section || !mount) {
      return false;
    }

    const widget = Array.from(document.querySelectorAll(widgetSelector)).find(
      (element) => element.parentElement !== mount
    );

    if (!widget) {
      const currentWidget = mount.querySelector(widgetSelector);
      moveWidgetHeader(section, currentWidget);

      if (currentWidget) {
        section.removeAttribute("hidden");
      }

      return false;
    }

    mount
      .querySelectorAll(`${widgetSelector}[${movedAttribute}]`)
      .forEach((element) => {
        if (element !== widget) {
          element.remove();
        }
      });

    mount.appendChild(widget);
    widget.setAttribute(movedAttribute, "true");
    moveWidgetHeader(section, widget);
    section.removeAttribute("hidden");

    return true;
  };

  const startObserver = () => {
    moveWidget();

    const observer = new MutationObserver(() => {
      moveWidget();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserver, { once: true });
  } else {
    startObserver();
  }
})();
